/*
 * Created on Wed Oct 11 2023 4:56:55 PM
 *
 * ***************************************************************************************
 * Copyright (c) AVPS Technologies Inc 2023 
 *
 * All Rights Reserved
 * Unpublished rights are reserved under the copyright laws of the United States.
 * The software contained in this media is proprietary to and embodies confidential
 * the technology of AVPS Technologies Inc. Possession, use, duplication or
 * dissemination of the software and media is authorized only pursuant to a valid
 * written license from AVPS Technologies Inc.
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * RESTRICTED RIGHTS LEGEND Use, duplication, or disclosure by the U.S. Government
 * is subject to restrictions as set forth in Subparagraph (c) (1) (ii) of DFARS
 * 252.227-7013 or in FAR 52.227-19, as applicable.
 ****************************************************************************************
 */

import { motion } from 'framer-motion';
import { AlertCircle } from 'lucide-react';

const AvailabilityStatus = ({ status, onViewSchedule }) => {
  if (!status) return null;

  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      className={`p-4 rounded-xl border-2 ${status.type === 'success'
          ? 'bg-emerald-50 border-emerald-200'
          : 'bg-amber-50 border-amber-200'
        }`}
    >
      <div className="flex items-start">
        <AlertCircle
          className={`w-4 h-4 mt-0.5 mr-2 ${status.type === 'success' ? 'text-emerald-600' : 'text-amber-600'
            }`}
        />
        <div>
          <span className={`text-sm font-medium ${status.type === 'success' ? 'text-emerald-700' : 'text-amber-700'
            }`}>
            {status.message}
          </span>
          {status.type === 'warning' && (
            <button
              onClick={onViewSchedule}
              className="block text-sm text-amber-600 hover:text-amber-700 font-medium mt-1"
            >
              View details and manage unavailable dates
            </button>
          )}
        </div>
      </div>
    </motion.div>
  );
};

export default AvailabilityStatus;